module.exports = __webpack_public_path__ + "static/media/caret-right.ee6f0641.svg";